import { object, SchemaOf, string } from 'yup';

import { CreateKubeConfigEnvironment } from '@/react/portainer/environments/environment.service/create';
import { useNameValidation } from '@/react/portainer/environments/common/NameField/NameField';
import { metadataValidation } from '@/react/portainer/environments/common/MetadataFieldset/validation';

export function useValidation(): SchemaOf<CreateKubeConfigEnvironment> {
  return object({
    name: useNameValidation(),
    kubeConfig: string().required('Kubeconfig file is required.'),
    meta: metadataValidation(),
  });
}
